import { useContext, useState } from 'react'
import { Formik } from 'formik';
import * as yup from "yup";
import { Box, Button, CircularProgress, Dialog, DialogContent, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import axios from 'axios';
import { AdminContext } from '../../../../../context/AdminContext';

function ChangeSectionDialog({ sections, lesson, dialogOpen, handleClose, onFormSubmited }) {

    const { token } = useContext(AdminContext);
    const [isUploading, setUploading] = useState(false);

    var initialValues = {
        newSectionId: lesson ? lesson.section_id : -1,
    };

    var validationObject = {
        newSectionId: yup.number().required("Section is required"),
    };

    const sectionChangeSchema = yup.object().shape(validationObject);

    const submitForm = async (values) => {
        setUploading(true);
        console.log("values: ", values);
        console.log("lesson: ", lesson);

        await axios.patch(`${process.env.REACT_APP_API_URL}course/moveLessonToAnotherSection?token=${token}&newSectionId=${values.newSectionId}&lessonId=${lesson.id}`, {}).catch((err) => {
            console.log("err: " + err);
            setUploading(false);
        }).then((response) => {
            if (response && response.data.success === true && response.data.status === 201) {
                setUploading(false);
                onFormSubmited();
            }
        });

    }

    return (
        <Dialog
            sx={{ margin: "0 auto" }}
            fullWidth
            maxWidth="sm"
            open={dialogOpen}
            onClose={handleClose}>
            <Box m="20px" textAlign="center">
                <Typography variant='h3'>
                    Change Section
                </Typography>
            </Box>
            <DialogContent>
                <Box>
                    <Formik
                        onSubmit={submitForm}
                        initialValues={initialValues}
                        validationSchema={sectionChangeSchema}
                    >
                        {({ values, errors, touched, handleBlur, handleChange, handleSubmit }) => (
                            <form onSubmit={handleSubmit}>
                                <Box display="grid" gap="15px" gridTemplateColumns={"repeat(1, minmax(0, 1fr))"} mx="75px" mb="25px">

                                    <FormControl fullWidth variant="filled" sx={{ gridColumn: "span 1" }}>
                                        <InputLabel id="filter-label">Section</InputLabel>
                                        <Select
                                            labelId="filter-label"
                                            label="Type"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            name={"newSectionId"}
                                            value={values.newSectionId}
                                            error={!!touched.newSectionId && !!errors.newSectionId}
                                        >
                                            {
                                                sections.map((section, index) => (
                                                    <MenuItem key={section.id} value={section.id}>
                                                        {`Section ${index + 1}: ${section.title}`}
                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>


                                </Box>
                                <Box display="flex" justifyContent="end" m="20px 20px 0px 20px">
                                    <Button
                                        type="submit"
                                        color="secondary"
                                        variant="contained"
                                        disabled={isUploading}
                                        onClick={() => console.log(errors)}>
                                        <Typography variant='h5'>Save</Typography>
                                        {
                                            isUploading &&
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                <CircularProgress size={16} sx={{ ml: "10px" }} />
                                            </div>
                                        }
                                    </Button>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Box>
            </DialogContent>
        </Dialog >
    )
}

export default ChangeSectionDialog